import { createFileRoute } from '@tanstack/react-router';

import { OfferApprovalRequest } from '../offer/ApprovalRequest/OfferApprovalRequest';

export const Route = createFileRoute('/offer/$offerId/approval-request')({
    component: OfferApprovalRequest,
});
